import React, { useState, useEffect, useMemo } from "react";
import { DialogPdf, DialogPdfHLPure, DialogSystemGLPure, DropDownBtnHLPure, FilterHLPure, GridSelectionHLPure, GridSemaforoPure, HeaderHLPure, InputFileHLPure, PromotionalFooterPure, SimpleLoading } from "../../pures";
import { Container, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { b64toBlob } from "./../../../validators";

import "./guest-repse-documents.view.css"
import { CellColumnOne, CellSemaforo, HeaderColumnOne, HeaderSemaforo } from "../../pures/gridSemaforo/gridSemaforo-cells";

const GuestRepseDocumentsView = (props) => {
    let {
        isLoading,
        showLoadingRequesting,
        showErrorRequesting,
        showCompletedRequesting,
        messageError,
        messageComplete,
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        contractors,
        selectedContractor,
        onContractorFilterChange,
        contracts,
        selectedContract,
        onContractSelected,
        getColorByContractStatus,
        documentsRepse,
        getColorByDocumentStatus,
        selectedYear,
        yearFilterOptions,
        onYearFilterChange,
        handleClickButtons,
        showModalPdf,
        handleFile,
        handleDeleteFile,
        toggleCloseShowModal,
        handleCreateWorkflow,
        isLoadingModalPdf,
        showAWS,
        urlPdf,
        selectedFile,
        selectedFileName,
        errorFile,
        contractor,
        itemGrid,
        monthSelected,
        showButton,
        messageButton,
    } = props

    const { t } = useTranslation();

    const [currentSystem, setCurrentSystem] = useState("");
    const [selectedFileBase64, setSelectedFileBase64] = useState('')
    const [blobUrl, setBlobUrl] = useState("");

    const mobileResolution = useMediaQuery("(max-width:530px)");

    let title = contractor && contractor.name ? contractor.name : ''
    let heightContainer = mobileResolution ? 450 : 650
    let widthContainer = mobileResolution ? 550 : 1000
    let heightBody = mobileResolution ? 230 : 400

    let infodevice = currentSystem.toLowerCase();
    let isMobile = infodevice.includes("android");
    isMobile = isMobile || infodevice.includes("iphone");
    isMobile = isMobile || infodevice.includes("ipad");
    isMobile = isMobile || infodevice.includes("mobile");

    const pdfAws = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])
    const pdf = useMemo(() => {
        const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : ''
        return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
    }, [selectedFileBase64])


    useEffect(() => {
        setCurrentSystem(navigator.userAgent);
    }, []);

    useEffect(() => {
        if (props.selectedFileBase64) {
            const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
            setBlobUrl(blob);
            setSelectedFileBase64(props.selectedFileBase64)
        }
    }, [props.selectedFileBase64]);

    const contractorFilterChange = (event) => {
        const selectedOption = event.target.value;
        onContractorFilterChange(selectedOption);
    }

    const yearFilterChange = (event) => {
        const selectedOption = event.target.value;
        onYearFilterChange(selectedOption);
    }

    const showSwiper = useMediaQuery("(max-width:1000px)");

    // CONTRACTS GRID
    const [contractsDataGrid, setContractsDataGrid] = useState(contracts);
    const adjustScrollbar = contracts.length > 4;
    const adjustScrollbarDocs = documentsRepse.length > 4;

    useEffect(() => {
        setContractsDataGrid(contracts);
    }, [contracts])

    const onRowClickContract = (contract) => {
        onContractSelected(contract);
    }

    const CellColumnOneContracts = (props) => {
        return <CellColumnOne {...props} onRowClick={onRowClickContract} />
    }

    const HeaderSemaforoContracts = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={contractsSwiperState} />
    }

    const CellSemaforoContracts = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByContractStatus}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={contractsSwiperState}
                onSlideChange={onContractSlideChange}
                onRowClick={onRowClickContract}
            />
        );
    }

    // GRID DOCUMENTS
    const HeaderSemaforoDocument = () => {
        return <HeaderSemaforo showSwiper={showSwiper} swiperState={documentSwiperState} />
    }

    const CellSemaforoDocument = (props) => {
        return (
            <CellSemaforo
                {...props}
                getColorByStatus={getColorByDocumentStatus}
                yearShown={selectedYear}
                showSwiper={showSwiper}
                swiperState={documentSwiperState}
                onSlideChange={onDocumentSlideChange}
                clickableColors={["red", "yellow", "gray", ""]}
                onClick={handleClickButtons}
            />
        );
    }

    // SWIPERS
    const [contractsSwiperState, setContractsSwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    });
    const [documentSwiperState, setDocumentSwiperState] = useState({
        currSlide: 0,
        prevSlide: 0,
        touchedId: null,
        active: false,
    })

    const onContractSlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (contractsSwiperState.currSlide == index) return;

        setDocumentSwiperState(prev => ({ ...prev, active: false }));
        setContractsSwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    const onDocumentSlideChange = (swiper, id) => {
        let index = swiper.activeIndex;
        if (documentSwiperState.currSlide == index) return;

        setContractsSwiperState(prev => ({ ...prev, active: false }));
        setDocumentSwiperState(prev => ({
            currSlide: index,
            prevSlide: prev.currSlide,
            touchedId: id,
            active: true,
        }));
    }

    useEffect(() => {
        const today = new Date();
        let initialIndex = selectedYear == today.getFullYear() ? today.getMonth() : 0;
        setDocumentSwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
        setContractsSwiperState({
            currSlide: initialIndex,
            prevSlide: initialIndex,
            touchedId: null,
            active: false,
        })
    }, [selectedYear])

    return (
        <div className="guestRepseDocumentsView-wrapper">
            {isLoading ? (
                <SimpleLoading />
            ) : (
                <div className="guestRepseDocumentsView-container">
                    <DialogSystemGLPure
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        showLoadingRequesting={showLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        showErrorRequesting={showErrorRequesting}
                        messageError={messageError}
                        messageComplete={messageComplete}
                        showButton={showButton}
                        messageButton={messageButton}
                    />

                    <Grid
                        container
                        className="guestRepseDocumentsView-body"
                        spacing={2}
                        xs={12}
                    >
                        <Grid item xs={12}>
                            <HeaderHLPure title={`Reportar REPSE`} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid
                                container
                                xs={12}
                                className="guestRepseDocumentsView-filter"
                            >
                                <Grid item>
                                    {contractors.length > 0 && <DropDownBtnHLPure
                                        labelDropDown={"Proveedor REPSE"}
                                        optionsDropDown={contractors}
                                        optionsValue={selectedContractor?.id}
                                        nameOption="name"
                                        valueItem="id"
                                        onDropDownChange={contractorFilterChange}
                                        flex
                                    />
                                    }
                                </Grid>
                                <Grid item>
                                    <FilterHLPure
                                        options={yearFilterOptions}
                                        optionsValue={selectedYear.toString()}
                                        nameOption="year"
                                        valueItem="yearValue"
                                        onFilterChange={yearFilterChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className="guestRepseDocumentsView-grid-contracts">
                            <GridSelectionHLPure
                                skip={0}
                                take={contractsDataGrid.length}
                                // dataGrid={contractsDataGrid.map(item => item.id == selectedContract?.id ? { ...item, selected: true } : { ...item })}
                                dataGrid={contractsDataGrid}
                                onRowClick={onRowClickContract}
                                pageable={false}
                                resizable={true}
                                styleGrid={adjustScrollbar ? { maxHeight: '310px' } : null}

                                titleRow1={"Contrato"}
                                cellColumnOne={CellColumnOneContracts}
                                headerColumnOne={HeaderColumnOne}

                                columnTwo
                                titleRow2={""}
                                cellColumnTwo={CellSemaforoContracts}
                                headerColumnTwo={HeaderSemaforoContracts}
                            />
                        </Grid>
                        <Grid item xs={12} className="guestRepseDocumentsView-grid-documents" style={{ marginTop: '25px' }}>
                            <GridSelectionHLPure
                                skip={0}
                                take={documentsRepse.length}
                                pageable={false}
                                dataGrid={documentsRepse}
                                styleGrid={adjustScrollbarDocs ? { maxHeight: '310px' } : null}
                                titleRow1={"Documento"}
                                cellColumnOne={CellColumnOne}
                                headerColumnOne={HeaderColumnOne}

                                columnTwo
                                titleRow2={""}
                                cellColumnTwo={CellSemaforoDocument}
                                headerColumnTwo={HeaderSemaforoDocument}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PromotionalFooterPure />
                        </Grid>
                    </Grid>

                    {showModalPdf && (
                        <DialogPdfHLPure
                            title={t("signatureRequestView2.uploadDocument")}
                            description={itemGrid.name || "Subir documento"}
                            saveBtn={t("signatureRequestView2.uploadDocument")}
                            canelBtn={t("button.cancel")}
                            width={widthContainer}
                            height={heightContainer}
                            heightBody={heightBody}
                            handleFile={handleFile}
                            handleDeleteFile={handleDeleteFile}
                            cancel={toggleCloseShowModal}
                            handleSubmitProfile={handleCreateWorkflow}
                            loadingComponent={isLoadingModalPdf}
                        >

                            <div className="contractingRegistrationDocumentsView-card">
                                <Grid container lg={12} md={12} sm={12} es={12}>
                                    <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        es={12}
                                        className="container-btns-pdf"
                                    >
                                        {
                                            itemGrid.compliance[monthSelected].canUpload
                                                ? <InputFileHLPure
                                                    messageBtn={t("digitalContractTemplatesDetail.Document")}
                                                    flex={true}
                                                    acceptFile={"application/pdf"}
                                                    selectedFile={selectedFile}
                                                    selectedFileName={selectedFileName}
                                                    errorFile={errorFile}
                                                    handleFile={e => handleFile(e)}
                                                    handleDeleteFile={e => handleDeleteFile(e)}
                                                    tooltipShow={true}
                                                    positionTooltip={'right'}
                                                    titleTooltip={t('digitalContractTemplatesDetail.DocumentTooltipTitle')}
                                                    descriptionTooltip={t('digitalContractTemplatesDetail.DocumentTooltipDescription')}
                                                    labelActive={false}
                                                    informationIcon={true}
                                                />
                                                : <p>Este documento está siendo validado</p>
                                        }

                                    </Grid>
                                    {/*View document*/}
                                    <Grid container lg={12} md={12} sm={12} es={12}>
                                        {!isMobile && showAWS ? (
                                            <Grid item lg={12} md={12} sm={12} es={12}>
                                                {pdfAws}
                                            </Grid>
                                        ) : null}

                                        {props.selectedFile && (
                                            <React.Fragment>
                                                {!isMobile && !showAWS ? (
                                                    <Grid item lg={12} md={12} sm={12} es={12}>
                                                        {pdf}
                                                    </Grid>
                                                ) : null}

                                                {isMobile && (
                                                    <div className="pdf-btn-profile">
                                                        <DialogPdf blobUrl={blobUrl} />
                                                    </div>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogPdfHLPure>
                    )}
                </div>
            )
            }
        </div>
    );
}

export default GuestRepseDocumentsView;